import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';

import { REDIRECT_PAGE } from '@/shared/redirect/constants';
import z from 'zod';

import { getLoginRedirectPath } from '@/entities/auth/utils/get-login-redirect-path';
import { LoginPage } from '@/features/login/login-page';

const searchSchema = z
  .object({
    token: z.string().optional(),
    utm_campaign: z.string().optional(),
    utm_content: z.string().optional(),
    utm_medium: z.string().optional(),
    utm_source: z.string().optional(),
    utm_term: z.string().optional(),
    redirectPage: z.enum(REDIRECT_PAGE).optional(),
  })
  .catchall(z.unknown());

export const Route = createFileRoute('/login/')({
  validateSearch: searchSchema,
  beforeLoad: async (ctx) => {
    const token = ctx.search.token;
    const redirectPage = ctx.search.redirectPage;
    try {
      const redirectPath = await getLoginRedirectPath(token, redirectPage);
      if (redirectPath) {
        throw redirect(redirectPath);
      }
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }

      return;
    }
  },
  component: LoginPage,
});
